<template>
  <g-master :name="master.endpoint"
            :endpoint="master.endpoint"
            :tableSetup="master.tableSetup"
            :modalFieldsSetup="master.modalFieldsSetup"
            :actions="false"
            :parentData="parentData"
            ref="masterComponent"
  >
  </g-master>
</template>

<script>
  export default {
    props: ['id_emp', 'fecha_desde', 'fecha_hasta'],
    data () {
      return {
        master: {
          endpoint: 'recognition_year',
          tableSetup: {
            tableConfig: {
              rowKey: 'id_recognition'
            },
            actions: false,
            columns: [
              {title: 'Nombre', dataIndex: 'name', sorter: true},
              {title: 'Area', dataIndex: 'qualified_rol', sorter: true},
              {title: 'Observación', dataIndex: 'obs', sorter: true},
              {title: 'Calificación', dataIndex: 'qualification_desc', sorter: true},
              {title: 'Fecha de calificación', dataIndex: 'year', sorter: true}
            ]
          }
        }
      }
    },
    methods: {
      loadData () {
        this.$refs.masterComponent && this.$refs.masterComponent.$refs.datatable.loadData()
      }
    },
    computed: {
      parentData () {
        return {
          id_emp: this.id_emp,
          // year: this.anio,
          fecha_desde_reco_year: this.fecha_desde,
          fecha_hasta_reco_year: this.fecha_hasta
        }
      }
    }
  }
</script>


// WEBPACK FOOTER //
// src/customization/GlobalBPOCore/pages/GestionHumana/Reconocimiento/ReconocimientoAnualDetalle.vue